module.exports = __webpack_public_path__ + "img/no-img.6c3e4f5c.png";